import { LitEntity, html } from '../../utility/lit-entity';
import '../../common/bn-placeholder';

const displayNames = {
  '3d': '3D',
  lidar: 'Lidar',
  hd: 'HD',
};

class DeviceSensorType extends LitEntity {
  render() {
    if (!this.entity || this.loading) {
      return html`<bn-placeholder></bn-placeholder>`;
    }

    const { sensorType, has3DSensor } = this.entity.properties;
    const type = displayNames[sensorType || (has3DSensor ? '3d' : 'lidar')];

    return html`${type}`;
  }
}

window.customElements.define('device-sensor-type', DeviceSensorType);
